'use client'
import * as React from 'react'
const Toggle = require('react-toggle').default
import 'react-toggle/style.css'
import { cn } from '@/lib/utils'
import { VariantProps, cva } from 'class-variance-authority'

const toggleVariants = cva('flex items-center space-x-2', {
  variants: {
    weight: {
      medium: 'font-medium',
      regular: 'font-normal'
    }
  },
  defaultVariants: {
    weight: 'regular'
  }
})

interface ToggleProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof toggleVariants> {
  label: string
  id: string
  defaultChecked?: boolean
  onChange?: React.ChangeEventHandler<HTMLInputElement>
}

const ToggleComponent = React.forwardRef<HTMLDivElement, ToggleProps>(
  ({ className, defaultChecked, onChange, label, ...props }, ref) => {
    return (
      <div className={cn(toggleVariants(props), className)} ref={ref} {...props}>
        <label htmlFor={props.id}>{label}</label>
        <Toggle id={props.id} defaultChecked={defaultChecked} onChange={onChange} />
      </div>
    )
  }
)

ToggleComponent.displayName = 'Toggle'

export { ToggleComponent }
